import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useOnboardingStatus } from '@/hooks/useOnboarding';

export const OnboardingRedirect = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const { data: onboardingStatus, isLoading } = useOnboardingStatus();

  useEffect(() => {
    // Don't redirect if already on onboarding page or other excluded routes
    const excludedRoutes = ['/onboarding', '/auth', '/invite/accept', '/'];
    const isExcluded = excludedRoutes.some(route => location.pathname.startsWith(route));

    if (!isLoading && user && !onboardingStatus?.completed && !isExcluded) {
      // New user - redirect to onboarding
      navigate('/onboarding');
    }
  }, [user, onboardingStatus, isLoading, location.pathname, navigate]);

  return <>{children}</>;
};
